export default "__VITE_ASSET__C_lwA2SM__"